var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.875,
    cy: 17,
    r: 17,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 14.1718C22.875 17.3219 19.6819 17.3704 19.6819 18.5345V18.8322C19.6819 19.1435 19.445 19.396 19.1528 19.396H17.1402C16.848 19.396 16.6111 19.1435 16.6111 18.8322V18.4254C16.6111 16.7461 17.806 16.0748 18.7089 15.5354C19.4832 15.0729 19.9577 14.7583 19.9577 14.1458C19.9577 13.3356 18.9878 12.7978 18.2036 12.7978C17.1812 12.7978 16.7092 13.3135 16.0457 14.2057C15.8669 14.4463 15.5404 14.4909 15.3109 14.3055L14.0841 13.3143C13.859 13.1324 13.8085 12.7945 13.9676 12.5456C15.0093 10.9157 16.3362 10 18.402 10C20.5656 10 22.875 11.7995 22.875 14.1718ZM19.9983 22.0268C19.9983 23.1149 19.1676 24 18.1465 24C17.1254 24 16.2947 23.1149 16.2947 22.0268C16.2947 20.9388 17.1254 20.0537 18.1465 20.0537C19.1676 20.0537 19.9983 20.9388 19.9983 22.0268Z",
    fill: "#9EA9B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.6ce8766feba947dcdc6287ee9247104a.svg";
export { ForwardRef as ReactComponent };